import { render, staticRenderFns } from "./ActiveCourses.vue?vue&type=template&id=146ffcc7"
import script from "./ActiveCourses.vue?vue&type=script&lang=js"
export * from "./ActiveCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports